export const EMAIL_SERVICE_ID = 'c2VydmljZV95dmZ4anFv';
export const EMAIL_USER_ID = 'dXNlcl9KY1pTQzM1cHJGNE9WUm5KNjM4eHk=';
export const EMAIL_TEMPLATE_ID = 'dGVtcGxhdGVfZTlxZnJkcg==';
export const CAPTCHA_VALUE =  'NkxmQjljY2FBQUFBQU4wcmNzd210LXhvQ2Y1NWc1Y0h2YW81azVPaA==';
